import {
    Resolver,
} from 'one-core';

/**
 * Web application url resolver
 * Simply returns the input url without
 * any modifications
 * @param url url to resolve
 * @returns url without any modifications
 */
export const resolver: Resolver = (
    url => url
);
